const showMore = () => {
    var buttons = document.querySelectorAll('.showMoreBtn');

    buttons.forEach(button => {
        var group = button.getAttribute('data-group');
        var items = document.querySelectorAll(`.showMoreItem[data-group="${group}"]`);

        button.addEventListener('click', () => {
            items.forEach(item => {
                item.classList.remove('--hidden');
            });
            button.classList.add('d-lg-none');
        });
    });
}

export default showMore;